<template>
  <el-form label-position="left" label-width="auto" :model="formData" ref="form" :rules="rules" :disabled="readonly">
    <el-form-item :label="$t('会员名称')" prop="name">
      <el-input :placeholder="$t('会员等级')" v-model="formData.name" />
    </el-form-item>
    <el-form-item :label="$t('积分')" prop="integral">
      <el-input :placeholder="$t('积分')" v-model.number="formData.integral" />
    </el-form-item>

    <el-form-item :label="$t('会员权益')" prop="equity">
      <wangeditor ref="editor" v-model="formData.equity" :upload-img-server="$api.file.uploadEditor" v-if="!readonly" />
      <div v-else class="equity-box" v-html="formData.equity"></div>
    </el-form-item>

    <el-form-item v-if="!readonly">
      <el-button type="primary" @click="handleSave">{{$t('保存')}}</el-button>
      <el-button @click="resetForm">{{$t('重置')}}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import Wangeditor from "@/components/Wangeditor";
export default {
  name: "LevelForm",
  components: {Wangeditor},
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 是否查看
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        name: "",
        integral: "",
        equity: "",
      },
      rules: {
        name: {required: true, message: '请输入会员名称', trigger: 'blur'},
        integral: [
          {required: true, message: '请输入积分', trigger: 'blur'},
          {pattern: /^\d+$/, message: '请输入正整数', trigger: 'blur'}
        ],
        equity: {required: true, message: '请输入会员权益', trigger: 'change'}
      }
    }
  },
  methods: {
    // 保存
    handleSave() {
      this.$refs.form.validate(valid => {
        if(!valid) return;
        this.$emit("save", {...this.formData});
      })
    },

    // 重置表单
    resetForm() {
      this.$refs.form.resetFields();
      this.$refs.editor.clear();
    }
  },
  watch: {
    data: {
      handler(val) {
        for (const key in this.formData) {
          this.formData[key] = val[key];
        }
      },
      immediate: true,
      deep: true,
    }
  }
}
</script>

<style scoped>
.el-form {
  max-width: 700px;
}

.equity-box {
  width: 100%;
  border: 1px solid #dddddd;
  box-sizing: border-box;
  padding: 8px;
  border-radius: 4px;
}

</style>
